export class CheckVinRequest {
  vin: string;
}
